// 登录态管理:token 与用户信息同时存 localStorage(刷新保持)与响应式 ref(组件实时联动)
import { ref } from 'vue'

const TOKEN_KEY = 'auth_token'
const USER_KEY = 'auth_user'

function readUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  } catch (e) {
    return null
  }
}

const tokenRef = ref(localStorage.getItem(TOKEN_KEY) || '')
const userRef = ref(readUser())

export function getToken() {
  return tokenRef.value
}

export function getUser() {
  return userRef.value
}

export function setAuth(token, user) {
  tokenRef.value = token || ''
  userRef.value = user || null
  localStorage.setItem(TOKEN_KEY, tokenRef.value)
  localStorage.setItem(USER_KEY, JSON.stringify(userRef.value || {}))
}

export function clearAuth() {
  tokenRef.value = ''
  userRef.value = null
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}
